import React, { useState } from "react";
import { Alert, CircularProgress, Dialog, DialogContent, FormControlLabel, FormGroup, Switch, Typography } from "@mui/material";

import { DataGrid, GridColDef } from "@mui/x-data-grid";

import { SystemMailEdit } from "./SystemMailEdit";
import { Box } from "@mui/system";
import { useFetch } from "../../hooks/useFetch";
import { ISystemMail } from "./ISystemMail";


const columns: GridColDef[] = [
    { field: 'id', 
      headerName: 'Nr.', 
      width: 90 
    },
    { field: 'Title', 
      headerName: 'Bezeichnung', 
      flex: 1
    },
]




export const SystemMailOverview:React.FC = () => {
    const [mailArray, setMailArray, wasSuccessfullyMailArray] = useFetch<ISystemMail[]>("/systemmail");
    //
    const [showPublic, setShowPublic] = useState(false);
    //
    const [idSystemMail, setIdSystemMail] = useState<number|null>(null);
    //
    const [wasSaved, setWasSaved] = useState(false);
    const [wasSavedSuccesfully, setWasSavedSuccesfully] = useState(false);
    //
    const [scopeArray,setCcopeArray] = React.useState(localStorage.getItem("scope")?.split(","))

    if (!wasSuccessfullyMailArray) {
        return <Alert severity="error">Fehler!</Alert> 
    }
    else if (mailArray === undefined) {
        return <CircularProgress/>
    } else {
        return(
            <>


                <Dialog open={idSystemMail !== null} onClose={() => setIdSystemMail(null)} maxWidth="lg" fullWidth>
                    <DialogContent>
                        {(idSystemMail !== null) &&
                            <SystemMailEdit 
                                key={`idSystemMail-${idSystemMail}`}
                                currentId={idSystemMail}
                                setCurrentId={setIdSystemMail}
                                currentArray={mailArray}
                                setCurrentArray={setMailArray}
                                setWasSaved={setWasSaved}
                                setWasSavedSuccesfully={setWasSavedSuccesfully}
                            />
                        }

                    </DialogContent>
                </Dialog>



                <Typography variant="h5" sx={{mt: 5, mb: 2}}>
                    E-Mail vorlagen
                </Typography>
                <Box sx={{mt: 2}}/>
                <DataGrid
                    rows={mailArray}
                    columns={columns}
                    onRowClick={(params,event,details) => setIdSystemMail(Number(params.id))}
                    autoHeight
                />
            </>
        )
    }

    
}